/* The House of Cobalt, product page behaviors:
   - accordion toggle
   - quantity stepper
   - image thumbnail switch
   - variant selector (updates hidden variant id + price)
*/
(function () {
  // Accordion
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (head) head.parentElement.classList.toggle('open');
  });

  // Qty stepper
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = document.getElementById('ProductQty');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var max = parseInt(input.getAttribute('max') || 99, 10);
    var min = parseInt(input.getAttribute('min') || 1, 10);
    input.value = Math.max(min, Math.min(max, (parseInt(input.value, 10) || 1) + delta));
  });

  // Thumbnail switch, preload + decode before swapping so the stage never
  // flashes blank on tap (mobile especially), with a short opacity crossfade.
  var preloaded = {};
  function preloadThumbs() {
    document.querySelectorAll('.product-thumb[data-thumb-src]').forEach(function (t) {
      var s = t.getAttribute('data-thumb-src');
      if (!s || preloaded[s]) return;
      var im = new Image();
      im.src = s;
      preloaded[s] = im;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preloadThumbs);
  else preloadThumbs();

  var swapToken = 0;
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product-thumb');
    if (!thumb) return;
    e.preventDefault();
    var src = thumb.getAttribute('data-thumb-src');
    var main = document.getElementById('ProductMainImage');
    document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    if (!main || !src || main.src === src) return;
    var token = ++swapToken;
    var im = preloaded[src] || new Image();
    if (!preloaded[src]) { im.src = src; preloaded[src] = im; }
    var apply = function () {
      if (token !== swapToken) return; // a newer tap won
      main.style.opacity = '0';
      setTimeout(function () {
        if (token !== swapToken) return;
        main.src = src;
        main.style.opacity = '1';
      }, 120);
    };
    if (im.decode) im.decode().then(apply).catch(apply);
    else if (im.complete) apply();
    else { im.onload = apply; im.onerror = apply; }
  });

  // Variant selector
  var productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;
  var product;
  try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

  function findVariant() {
    var selects = document.querySelectorAll('[data-variant-option]');
    var values = Array.prototype.map.call(selects, function (s) { return s.value; });
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === values[i]; });
    });
  }
  function formatPrice(cents) {
    var d = (cents / 100);
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)) + ' USD';
  }
  function update() {
    var variant = findVariant();
    if (!variant) return;
    document.getElementById('ProductVariantId').value = variant.id;
    var priceEl = document.getElementById('ProductPrice');
    if (priceEl) priceEl.textContent = formatPrice(variant.price);
    var addBtn = document.querySelector('.add-to-bag');
    if (addBtn) {
      if (variant.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = 'Add to bag'; }
      else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Sold out'; }
    }
  }
  document.querySelectorAll('[data-variant-option]').forEach(function (s) { s.addEventListener('change', update); });
})();
